export default {
  tabs: {
    keyLights: 'Key Lights',
    sideLights: 'Side Lights',
    statusIsland: 'Status Island Light',
    stripLight: 'Light Strip',
    nameplateLight: 'Nameplate Light',
    indicatorLight: 'RGB Indicator Light',
    audioRhythm: 'Audio Rhythm',
  },
  select: {
    selectAll: 'Select All',
    invertSelection: 'Invert Selection',
  },
  vibrant: 'Vibrant',
  current: 'Current',
  preset: 'Preset',
  lightingSetting: 'Lighting Settings',
  switchTooltip: {
    turnOff: 'Turn off lighting',
    turnOn: 'Turn on lighting',
  },
  audioShareTooltip: 'Click the button on the right to share audio (system sound required)',
  referenceOnly: 'Illustration only. Values are for reference.',
  colorTitle: 'Color',
  audioRhythmStatus: {
    idle: 'Share Audio',
    stop: 'Stop Collecting',
    requesting: 'Requesting',
    systemAudio: 'System Audio',
    microphone: 'Microphone',
    error: 'Audio Error',
    noAudioTrack:
      'No audio track received. Enable "Share system audio" or "Share tab audio" in the picker.',
    shareEnded: 'Audio sharing ended',
  },
  audioRhythmSettings: {
    title: 'Settings',
    lowSensitivity: 'Low Sensitivity',
    midSensitivity: 'Mid Sensitivity',
    highSensitivity: 'High Sensitivity',
    brightness: 'Brightness',
    trailSmoothing: 'Trail Smoothing',
  },
  audioRhythmColor: {
    neonCyan: 'Neon Cyan',
    neonBlue: 'Neon Blue',
    electricArc: 'Electric Arc',
    neonPurple: 'Neon Purple',
    neonPink: 'Neon Pink',
    flame: 'Flame',
    neonGreen: 'Neon Green',
    neonYellow: 'Neon Yellow',
    neonOrange: 'Neon Orange',
    rainbow: 'Rainbow',
  },
  customLighting: {
    title: 'Custom Lighting',
    description:
      'The Chinese name must not exceed 4 characters; the English name must not exceed 12 characters',
    singleColorRadio: 'Single-color Static Lighting Effects',
    twoToneGradientRadio: 'Two-tone Gradient Lighting Effect',
  },
  deleteCustom: {
    title: 'Delete Custom Lighting Effects',
    description:
      'Confirm deletion of this lighting effect file. Once deleted, it cannot be recovered and must be added again.',
  },
  lightMode: {
    lightingTitle: 'Lighting Mode',
    chargingTitle: 'Charging Status',
    ambientLightingTitle: 'Display Ambient Lighting',
    ambientLightingExcerpt:
      'Displaying custom lighting effects first; do not display while the mouse is charging.',
    chargingLightingTitle: 'Charging Indicator Light',
    chargingLightingExcerpt:
      'When the mouse is charging, the ambient lighting switches to charging mode.',
    syncTitle: 'Sync Light Effects',
  },
  brightness: 'Brightness',
  lightingSpeed: 'Lighting Speed',
  lightingDirection: 'Lighting Direction',
  verticalGradient: 'Vertical Gradient',
  horizontalGradient: 'Horizontal Gradient',
  forward: 'Forward',
  reverse: 'Reverse',
  directionTips: 'Forward / Reverse',
  directionLeftToRight: 'Left → Right',
  directionRightToLeft: 'Right → Left',
  directionTopToBottom: 'Top → Bottom',
  directionBottomToTop: 'Bottom → Top',
  directionCenterToOuter: 'Center → Out',
  directionOuterToCenter: 'Out → Center',
  directionCounterClockwise: 'Counterclockwise',
  directionClockwise: 'Clockwise',
  effect: {
    wave_flow: 'Wave Flow',
    colorful_raindrop_falling: 'Colorful Raindrop Falling',
    breathing: 'Breathing',
    stars_twinkle: 'Stars Twinkle',
    ripple: 'Ripple',
    shadow_chasing: 'Shadow Chasing',
    swiftly: 'Swiftly',
    sudden_turn: 'A Sudden Turn of Events',
    great_winged: 'The Great Winged',
    seeking_plum_blossoms: 'Seeking Plum Blossoms in the Snow',
    snap: 'Snap',
    click_diffusion: 'Ripp',
    twinkling_stars: 'Twinkling Stars',
    rgb_constant: 'RGB Constant Brightness',
    blue_sky_white_clouds: 'Blue Sky and White Clouds',
    row_gradient: 'Row Gradient',
    col_gradient: 'Col Gradient',
    moba: 'MOBA',
    fps: 'FPS',
    car: 'CAR',
    rgb_flow: 'RGB Flow',
    static: 'Static',
    static_breathing: 'Static Breathing',
    /* P5/P6 Telink_Base 灯效 */
    spectrum_cycle: 'Spectrum Cycle',
    magic_color: 'Magic Color',
    /* ESPR/VPR VT_nrf54L_Base 灯效 */
    rgb_colorful: 'RGB Colorful',
    color_breathing: 'Color Breathing',
    battery_indicator: 'Battery Indicator',
    battery_indicator_tip: 'When selected, the current mouse battery level is shown first.',
    indicator: 'Charging Indicator',
    indicatorTip: 'Customize lighting effects when charging.',
    ambient: 'Ambient Lighting',
    ambientTip: 'Customize lighting effects for normal wireless use.',
    horse_race_lamp: 'Horse Race Lamp',
    sinusoid: 'Sinusoid',
    spiral: 'Spiral',
    fill: 'Fill',
    stacks: 'Stacks',
    swap: 'Swap',
    /* GCOME_AP protocol light modes 0-22 */
    game_mode: 'Custom Game Mode',
    spectrum: 'Spectrum Cycle',
    gradient: 'Gradient Step',
    flower: 'Flower Bloom',
    wave: 'Wave',
    wave_upr: 'Up-Down Wave',
    fountain: 'Fountain',
    glisten: 'Glisten Milky Way',
    vortex: 'Vortex Spin',
    tide: 'Tide',
    swing: 'Swing Waves',
    ripple_on: 'Static Ripple',
    single: 'Single Spot',
    cell: 'Grid Cell',
    knock: 'Piano Knock',
    across: 'Flowing Light',
    rain: 'Rainfall',
    starry: 'Starry Sky',
    firework: 'Firework',
    wave_bar: 'Wave Bar',
    off: 'Lights Off',
    /* GCOME_AP audio rhythm (software effects) */
    spectrum_bar: 'Spectrum Bar',
    central_pulse: 'Central Pulse',
    peak_meter: 'Peak Meter',
    scan_line: 'Scan Line',
    audio_wave: 'Wave',
    flame: 'Flame',
    beat_breathe: 'Beat Breathe',
  },
}
